<template>
  <header>
    <div class="navbar-left">
      <Modal
        ref="changeNameModal"
        title="ニックネームを変更"
        :bodyHeight="'350px'"
        :footerHeight="'100px'"
        :visibleNeverShowCheckbox="false"
        @agreeButtonClicked="changeName"
        titleIcon="el-icon-user"
      >
        <div style="flex-direction: column; width: 500px">
          <h3>ランキング用のニックネームを入力してください</h3>
          <p style="color: #888">※このニックネームは他のユーザーへ公開されます。</p>
          <el-input v-model="name" minlength="3" maxlength="16"></el-input>
          <div class="error">{{ nameError }}</div>
        </div>
      </Modal>
      <router-link to="/">
        <img class="logo" src="@/assets/nklogo_.png" />
      </router-link>
      <el-tooltip
        class="item"
        :open-delay="500"
        effect="dark"
        content="クリックするとランキングで表示されるニックネームを変更できます。"
        placement="bottom"
      >
        <div class="signed" @click="showCangeNameModal">
          <i class="el-icon-user" style="margin-right: 5px;" />
          {{ $store.state.userData.name }}
          でサインイン中
        </div>
      </el-tooltip>
    </div>
    <div class="navbar-right">
      <!-- <button class="button" @click="open">サポート</button> -->
      <!-- <router-link to="/subscribe" v-if="!purchased">
        <button class="button">プレミアムプランのご案内</button>
      </router-link>-->

      <router-link to="/faq">
        <button class="button white">
          Q&amp;A
          <!-- <i class="el-icon-question" /> -->
        </button>
      </router-link>

      <router-link to="/settings">
        <button class="button white">
          各種設定
          <!-- <i class="el-icon-s-tools" /> -->
        </button>
      </router-link>

      <button class="button white" @click="signOut">
        サインアウト
        <!-- <i class="el-icon-turn-off" /> -->
      </button>
    </div>
  </header>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
import { db } from "@/plugins/firebase";

export default {
  components: {
    Modal: require("@/components/Modal").default
  },
  mounted() {
    // console.log(this.$store.getters.user);
  },
  data() {
    return {
      name: "",
      drawer: false,
      direction: "ttb",
      form: "",
      category: "",
      nameError: "",
      nameValid: false
    };
  },
  destroyed() {},
  computed: {
    nameValid() {
      this.name.length < 16 && this.name > 2;
    }
  },
  watch: {
    name(name) {
      console.log(name);
      if (name.length > 16) {
        this.nameError =
          "ニックネームが長すぎます。16文字以下で入力してください。";
      } else if (name.length < 3 && name.length !== 0) {
        this.nameError =
          "ニックネームが短かすぎます。3文字以上で入力してください。";
      } else {
        this.nameError = "";
      }
    }
  },
  methods: {
    async load() {
      const userRankingRef = await db
        .collection("Ranking")
        .doc(this.$store.state.auth.user.uid)
        .get();
      if (userRankingRef.exists) {
        this.$store.commit("setName", userRankingRef.data().name);
      }
    },
    showCangeNameModal() {
      this.$refs.changeNameModal.showModal();
    },
    changeName() {
      const changeNameFunc = firebase
        .functions()
        .httpsCallable("changeRankingName");
      try {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "ニックネームを変更中です"
        });
        changeNameFunc({ name: this.name }).then(() => {
          this.load();
          this.$notify({
            type: "success",
            title: "成功",
            message: "ニックネームの変更が完了しました。"
          });
          loadingInstance.close();
        });
      } finally {
        this.$refs.changeNameModal.closeModal();
      }
    },
    open() {
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },
    onSubmit() {
      let self = this;
      const addMessage = firebase.functions().httpsCallable("sendFeedback");
      addMessage({
        message: self.form,
        url: location.href,
        category: self.category,
        name: self.$store.state.auth.user.name
      })
        .then(function(result) {
          self.$notify({
            title: "成功",
            message:
              "フィードバックを送信しました。ご協力頂き有難うございました",
            type: "success"
          });
          self.drawer = false;
        })
        .catch(err => {
          this.$notify({
            title: "失敗",
            message:
              "フィードバックの送信に失敗しました。大変お手数ですがフィードバック内容を masakazu_naoi@pronaid.co.jp 宛にメールで送信して頂ければ幸いです。",
            type: "error"
          });
          // self.drawer = false;
        });
    },
    signOut() {
      let loadingInstance = Loading.service({ fullscreen: true });

      firebase
        .auth()
        .signOut()
        .then(user => {
          this.$router.replace("/");
          loadingInstance.close();
        })
        .catch(err => {
          loadingInstance.close();
        });
    },
    handleClose(done) {
      this.$confirm("Are you sure you want to close this?")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  },
  computed: {
    purchased() {
      return (
        this.$store.state.userData.subscription.status === "active" ||
        this.$store.state.userData.subscription.status === "trialing"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.3rem;
}
header {
  position: absolute;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  height: 50px;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;

  @include mq(sm) {
    width: 800px;
  }
  @include mq(md) {
    width: 1000px;
  }
  @include mq(lg) {
    width: 1200px;
  }
  @include mq(xl) {
    width: 1300px;
  }

  .navbar-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    .signed {
      cursor: pointer;
      display: block;
      border-right: 1px solid rgba(0, 0, 0, 0.06);
      border-left: 1px solid rgba(0, 0, 0, 0.06);
      height: 50px;
      display: flex;
      font-size: 0.84rem;
      color: #555;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      margin-left: 20px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.035);
      }
    }

    .logo {
      padding-top: 5px;
      height: 27px;
      user-select: none;
    }

    .trial {
      margin-left: 20px;
      padding: 2px 12px;
      font-size: 0.8rem;
      border-radius: 20px;
      border: 1px solid #ccc;
      color: #666;
    }
  }
  .navbar-right {
    justify-content: flex-end;
    z-index: 10;
  }
}

.button {
  margin-left: 10px !important;
  padding: 3px 6px;
  font-weight: normal;
  font-size: 0.8rem;
}

ol {
  margin: 0;
  padding-left: 30px;
  li {
    display: list-item;
    padding: 0;
  }
}

dl.update {
  padding: 0;
  line-height: 1.8;
  width: 100%;
  font-size: 13px;
}
dl.update dt {
  width: 6em;
  float: left;
  margin: 0;
  padding: 0 0 0 5px;
}
dl.update dd {
  position: relative;
  margin: 0 0 5px;
  padding: 0 5px 5px 13em;
  border-bottom: 1px solid #ddd;
}
dl.update dd span.cat {
  display: block;
  position: absolute;
  top: 0;
  left: 7em;
  width: 4.5em;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-align: center;
  background-color: #eee;
  border-radius: 2px;
}
.radio-item {
  margin: 5px 10px;
}
.error {
  margin-top: 3px;
  color: #f56c6c;
  font-size: 0.8rem;
}
</style>
